// extracted by mini-css-extract-plugin
export default {"productsPage":"styles_productsPage__ZwtoV","productsWrapper":"styles_productsWrapper__foCej"};